"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogTransport = exports.LogEntryModel = void 0;
const enums_1 = require("../enums");
class LogEntryModel {
    constructor(message, level, data, error) {
        this.message = message;
        this.data = data;
        this.level = level;
        this.error = error;
    }
}
exports.LogEntryModel = LogEntryModel;
class ConsoleLogTransport {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.init = () => { };
        this.log = (entry) => {
            switch (entry.level) {
                case enums_1.Severity.Debug:
                    console.debug(entry.message);
                    break;
                case enums_1.Severity.Info:
                    console.info(entry.message, entry.data);
                    break;
                case enums_1.Severity.Error:
                    console.error(entry.message, entry.error);
                    break;
                case enums_1.Severity.Fatal:
                    console.error(entry.message, entry.error);
                    break;
                default:
                    throw new Error('Invalid loglevel');
            }
        };
    }
}
exports.ConsoleLogTransport = ConsoleLogTransport;
